/**
 * Which of the eight directions around a card a visitor comes in from, given where its previous page lies relative to this one
 * (dx, dy in px; cw, rh the grid's column width and row height, so a diagonal is judged in grid cells, not px).
 *
 * null when there is no side: the previous page is the SAME PLACE as this one (dx = dy = 0). The all-pages view maps every page to its
 * one slot, and "All other pages" holds many pages in one slot, so a visitor moving inside either has no neighbour it came from. The
 * old code fell through to its last line for a zero vector and answered "bottom right", so those visitors came up from the
 * bottom-right corner of the card (reported at 3x, and after scrubbing to the start of a surge).
 */
export type EntryDir = "top" | "bottom" | "left" | "right" | "tl" | "tr" | "bl" | "br";

export function entryDirection(dx: number, dy: number, cw: number, rh: number): EntryDir | null {
  if (Math.abs(dx) < 1e-6 && Math.abs(dy) < 1e-6) return null;
  const ax = Math.abs(dx) / (cw || 1), ay = Math.abs(dy) / (rh || 1);
  if (ax > 1.6 * ay) return dx < 0 ? "left" : "right";
  if (ay > 1.6 * ax) return dy < 0 ? "top" : "bottom";
  return ((dy < 0 ? "t" : "b") + (dx < 0 ? "l" : "r")) as EntryDir;
}
